import { useContext } from "react";
import NvsAuthorableProductContext from "../components/NVSAuthorableProduct/AuthorableProductProvider";

export function useIsPinchtoZoom() {
  const { isPinchZoom, setIsPinchZoom } = useContext(
    NvsAuthorableProductContext,
  );
  return { setIsPinchZoom, isPinchZoom };
}
